/* eslint-disable no-shadow */
export enum Periodicity {
    MONTHLY = 'MONTHLY',
    WEEKLY = 'WEEKLY',
    DAILY = 'DAILY',
}